<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='90px' ref='form' :model='form'>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='选择机构：'>
              <el-cascader
                ref='orgId'
                @change='changeOrg'
                :show-all-levels='false'
                v-model='form.orgId'
                :options='quyuList'
                :props="{
                                            checkStrictly: true,
                                            emitPath: false,
                                            label: 'label',
                                            value: 'orgId',
                                        }"
                clearable
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item label='工单类型：'>
              <el-select
                v-model='form.type'
                clearable
                placeholder='请选择'
              >
                <el-option
                  label='商业服务工单'
                  value='1'
                ></el-option>
                <el-option
                  label='残联服务工单'
                  value='3'
                ></el-option>
                <el-option
                  label='老干服务工单'
                  value='4'
                ></el-option>
                <el-option
                  label='民政服务工单'
                  value='6'
                ></el-option>
                <el-option
                  label='文明办服务工单'
                  value='10'
                ></el-option>
                <el-option
                  label='退役军人服务工单'
                  value='14'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='3' offset='1'>
            <el-button
              type='primary'
              class='searchBtns'
              @click='getlist'
            >查询
            </el-button
            >
          </el-col>
        </el-row>
        <el-row v-if='disBtn'>
          <el-col :span='3'>
            <el-button
              @click="handleSell('select', '')"
              type='primary'
              :disabled='orderIds.length == 0 || canDis'
            >派发
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div v-if='!levelStatus'>
      <el-table
        ref='multipleTable'
        :data='tableData'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        @selection-change='handleSelectionChange'
      >
        <el-table-column type='selection' fixed='left' width='40'>
        </el-table-column>
        <el-table-column
          prop='orderNum'
          label='工单流水号'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='customerName'
          label='客户姓名'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          prop='customerphone'
          label='联系方式'
          align='center'
          width='150'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='address'
          label='居住地址'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='servetypename'
          label='服务类别'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='timeStart'
          label='服务开始时间'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='timeEnd'
          label='服务结束时间'
          align='center'
          width='220'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='realPeriod'
          label='时间工作时间/分钟'
          align='center'
          width='180'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='estimateLevel'
          label='客户满意度'
          align='center'
          width='120'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          fixed='right'
          label='操作'
          align='center'
          :show-overflow-tooltip='true'
          width='150'
        >
          <template slot-scope='scope' v-if='disBtn'>
            <el-button
              type='text'
              :disabled='canDis'
              @click="handleSell('line', scope.row)"
            >派发
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container' v-if='!levelStatus'>
      <el-pagination
        :page-sizes='[10, 20, 50, 100]'
        :page-size='pageSize'
        :current-page.sync='pageNo'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination>
    </div>

    <!-- 派发弹框 -->
    <div class='sellDialog'>
      <el-dialog
        @close='closeSellDialog'
        :close-on-click-modal='false'
        title='派发'
        :visible.sync='sellDialogVisible'
        width='800px'
        class='dialog_container'
      >
        <div class='dialog_content'>
          <el-form
            label-width='100px'
            :model='sellformData'
            :rules='formDataRules'
            ref='sellformData'
          >
            <el-form-item label='工单派发数：' prop='pgdNum'>
              <el-input disabled v-model='sellformData.pgdNum'>
              </el-input>
            </el-form-item>
            <el-form-item label='完成时间：' prop='completeTime'>
              <el-date-picker
                v-model='sellformData.completeTime'
                type='date'
                :picker-options='pickerOptions'
                value-format='yyyy-MM-dd'
                placeholder='选择时间'
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label='派发机构：' prop='disOrgId'>
              <el-cascader
                disabled
                v-model='sellformData.disOrgId'
                :show-all-levels='false'
                :options='quyuList'
                :props="{
                                    checkStrictly: true,
                                    emitPath: false,
                                    label: 'label',
                                    value: 'orgId',
                                }"
                clearable
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label='接收机构：' prop='receiveOrgId'>
              <el-cascader
                v-model='sellformData.receiveOrgId'
                ref='receiveOrg'
                :options='receiveOrgListData'
                :show-all-levels='false'
                :props="{
                                    checkStrictly: true,
                                    emitPath: false,
                                    label: 'label',
                                    value: 'orgId',
                                }"
                clearable
              >
              </el-cascader>
            </el-form-item>
          </el-form>
          <div
            style='
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-top: 15px;
                        '
          >
            <el-button type='primary' @click='sellSave'
            >确 定
            </el-button>
            <el-button @click='sellDialogVisible = false'
            >取 消
            </el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 暂无权限派发 -->
    <div
      style='
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 50vh;
            '
      v-if='levelStatus'
    >
      <el-link type='danger' :underline='false'
      >当前账号暂无权限操作！
      </el-link
      >
    </div>
  </div>
</template>

<script>
import qualityManageDetail from './qualityManageDetail'
import headLine from '../components/headline'
import newBuildMsgDialogVue from '../../governmentAffairschildren/gridding/griddingModule/newBuildMsgDialog.vue'

export default {
  components: {
    headLine,
    qualityManageDetail
  },
  mounted() {
    this.getTree()
    this.$store.state.info.loginName == 'admin'
      ? (this.disBtn = false)
      : (this.disBtn = true) //admin禁止派发
  },
  watch: {
    'form.orgId'() {
      if (this.$refs.orgId) {
        this.$refs.orgId.dropDownVisible = false //监听值发生变化就关闭它
      }
    },
    'sellformData.receiveOrgId'() {
      if (this.$refs.receiveOrg) {
        this.$refs.receiveOrg.dropDownVisible = false //监听值发生变化就关闭它
      }
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
      allList: [],
      chooseIds: [],
      disBtn: true,
      canDis: false,
      levelStatus: false,
      quyuList: [], //派发机构
      receiveOrgListData: [], //接收结构
      sellDialogVisible: false, //派发弹窗
      //派发参数
      sellformData: {
        pgdIds: [],
        pgdNum: '',
        completeTime: null,
        disOrgId: null,
        receiveOrgId: null
      },
      orderIds: [], //表格选择框
      formData: {
        id: ''
      },
      dialogVisible: false,
      form: {
        type: '',
        orgId: '',
        dataIds: []
      },
      tableData: [],
      pageSize: 10,
      total: 0,
      pageNo: 1,
      isSearchContent: true,
      formDataRules: {
        completeTime: [
          {
            required: true,
            message: '请选择完成时间',
            trigger: 'blur'
          }
        ],
        receiveOrgId: [
          {
            required: true,
            message: '请选择接收机构',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    closeSellDialog() {
      this.getTree()
    },
    // 获取组织树
    getTree() {
      this.$post('/rbac/admin/org/info/OrgTreelist', { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            //当前机构等级不是总公司、省级、市级 就没有派发权限
            if (orgLevel == 0 || orgLevel == 1 || orgLevel == 2) {
              this.levelStatus = false
            } else {
              this.levelStatus = true
            }
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }

      return childrenEach(treeData, depth)
    },
    Reset() {
      this.form = {}
      this.getlist()
      if (this.chooseIds.length > 0) {
        let chooseId = this.chooseIds.filter((item) => {
          return !this.orderIds.some((it) => {
            item == it
          })
        })
        console.log('刷新页面', chooseId)
        this.chooseIds = chooseId
      }
      this.orderIds = []

      // console.log(chooseId, "刷新")
      //
    },
    // 分页切换
    handletableDataSize(val) {
      this.pageSize = val

      this.getlist()
    },
    // 分页切换
    handleTableDataChange(val) {
      this.pageNo = val
      this.chooseIds = this.chooseIds.concat(this.orderIds)
      this.chooseIds = [...new Set(this.chooseIds)]
      this.getlist()
    },
    //获取表格数据列表
    getlist() {
      const self = this
      if (!this.form.orgId) {
        this.$message.warning('请选择机构')
        return
      }
      if (this.form.orgId.length == 0) {
        this.$message.warning('请选择机构')
        return
      }
      this.$http
        .request({
          url: '/jjyl/servicePgd/info/findServicepgd',
          method: 'POST',
          data: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            city: '',
            servePersonName: '',
            serveproductName: '',
            servestationName: '',
            shequ: '',
            states: '2',
            // dataId:this.form.orgId,
            dataIds: this.form.dataIds,
            street: '',
            type: this.form.type,
            zone: ''
          }
        })
        .then((res) => {
          if (res.code === 200) {
            // this.chooseIds
            if (res.content && res.content.list) {
              this.tableData = res.content.list
              // console.log(this.chooseIds, "多选了")
              if (self.chooseIds.length > 0) {
                self.$nextTick(() => {
                  self.tableData.forEach((row) => {
                    if (
                      self.chooseIds.indexOf(row.id) >= 0
                    ) {
                      self.$refs.multipleTable.toggleRowSelection(
                        row,
                        true
                      )
                    }
                  })
                })
              }

              this.total = res.content.count
            } else {
              this.$message.warning('暂无数据~')
              this.tableData = []
              this.total = 0
            }
          }
        })
    },
    changeOrg() {
      if (
        this.form.orgId == null ||
        this.form.orgId == 'null' ||
        this.form.orgId == ''
      ) {
        this.tableData = []
      } else {
        // 改变选择机构的时候回显到派发弹窗内的派发机构
        if (this.form.orgId) {
          this.sellformData.disOrgId = this.changeDetSelect(
            this.form.orgId,
            'orgId',
            this.quyuList
          )
          //当前选择的机构id和账号绑定机构id一样的时候不给派发权限
          let currentDisOrgId =
            this.sellformData.disOrgId[
            this.sellformData.disOrgId.length - 1
              ] //当前派发机构id
          if (currentDisOrgId == this.$store.state.info.orgId) {
            this.canDis = true
          } else {
            this.canDis = false
          }
          //获取当前选择的机构所有下级的id(不含本级)
          let treeList = []
          let currentOrgChildrenList = this.chbehavior(
            this.quyuList,
            currentDisOrgId
          ) //获取选择当前机构下级
          if (!currentOrgChildrenList.children) {
            treeList.push({
              label: currentOrgChildrenList.label,
              orgId: currentOrgChildrenList.orgId
            })
            currentOrgChildrenList = treeList
          } else {
            treeList.push({
              label: currentOrgChildrenList.label,
              orgId: currentOrgChildrenList.orgId,
              children: currentOrgChildrenList.children
            })
            currentOrgChildrenList = treeList //带同级本身的数据
          }
          //获取当前选择的机构所有下级id集合
          let childrenIdList = this.getChildrenId(
            currentOrgChildrenList
          )
          this.form.dataIds = childrenIdList
        }
      }
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
    handleSelectionChange(val) {
      this.orderIds = []
      val.map((item) => {
        this.orderIds.push(item.id)
      })
    },
    chbehavior1(arr, id) {
      let res = []
      ;(function deepId(arr, id) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].orgId == id) {
            res = arr
          } else if (arr[i].children && res.length == 0) {
            deepId(arr[i].children, id)
          }
        }
      })(arr, id)
      return res
    },
    //派发
    handleSell(t, r) {
      let vm = this
      if (t == 'line') {
        vm.sellformData.pgdNum = 1 //table内派发数量始终为1
      } else {
        let chooseis = [...this.chooseIds, ...this.orderIds]
        chooseis = [...new Set(chooseis)]
        this.sellformData.pgdNum = chooseis.length
      }
      // console.log(this.chooseIds, this.orderIds, "测试")
      //弹窗内接收机构数据(接收结构对象 ==> 选择当前派发机构的同级机构(不含下级));
      let allDisOrg = vm.quyuList //派发机构集合
      let currentDisOrgId =
        vm.sellformData.disOrgId[this.sellformData.disOrgId.length - 1] //当前派发机构id
      let currentReceiveOrg = vm.chbehavior1(allDisOrg, currentDisOrgId) //递归拿到当前派发机构同等级的接收机构
      // 拿到非当前本身机构的所有机构
      let receiveOrgList = currentReceiveOrg.filter((val) => {
        return Number(val.orgId) != currentDisOrgId
      })
      receiveOrgList.map((item) => {
        item.children = null //去掉下级数据
      })
      vm.receiveOrgListData = receiveOrgList //接收机构最终数据
      vm.sellDialogVisible = true
    },
    //派发确定
    async sellSave() {
      let vm = this
      // orderIds
      let chooseis = [...this.chooseIds, ...this.orderIds]
      chooseis = [...new Set(chooseis)]
      this.sellformData.pgdIds = chooseis
      //兼容弹窗内带过来的派发机构回显传参问题
      if (typeof this.sellformData.disOrgId == 'string') {
        //直接选择一级给的是一个字符串:2  直接给服务端
        this.sellformData.disOrgId = this.sellformData.disOrgId
      } else {
        //选择多级给的是数组形式[1,2,3] 只取最后一个给服务端
        this.sellformData.disOrgId = this.sellformData.disOrgId
          .pop()
          .toString()
      }
      if (vm.sellformData.disOrgId == vm.sellformData.receiveOrgId) {
        vm.$message.warning('派发机构和接收机构不能一样')
        return
      }

      //获取接收结构的下级所有id(含自身id)
      let currentReceiveOrgId = vm.sellformData.receiveOrgId //当前接收机构id
      //获取当前接收机构所有下级的id
      let treeList = []
      let allList = []
      await this.$post('/rbac/admin/org/info/OrgTreelist', {
        isValid: 1
      }).then((res) => {
        if (res.code === 200) {
          allList = res.content
        }
      })

      let currentOrgChildrenList = this.chbehavior(
        allList,
        currentReceiveOrgId
      ) //获取选择当前接收机构下级

      if (!currentOrgChildrenList.children) {
        treeList.push({
          label: currentOrgChildrenList.label,
          orgId: currentOrgChildrenList.orgId
        })
        currentOrgChildrenList = treeList
      } else {
        treeList.push({
          label: currentOrgChildrenList.label,
          orgId: currentOrgChildrenList.orgId,
          children: currentOrgChildrenList.children
        })
        currentOrgChildrenList = treeList //带同级本身的数据
      }
      //获取当前选择的机构所有下级id集合
      let childrenIdList = this.getChildrenId(currentOrgChildrenList)

      vm.sellformData.dataIds = childrenIdList
      vm.$refs.sellformData.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          vm.$http
            .request({
              url: '/jjyl/admin/serviceManagement/info/insert',
              method: 'POST',
              data: vm.sellformData
            })
            .then((res) => {
              if (res.code === 200) {
                vm.$message(res.message)
                setTimeout(function() {
                  vm.sellDialogVisible = false
                  vm.orderIds = []
                  vm.chooseIds = []
                  vm.getlist()
                }, 2000)
                loading.close()
              } else {
                loading.close()
              }
            }).catch((error) => {
            loading.close()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang='less'>
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.operation-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.operation-color {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
<style lang='less' scoped>
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}
</style>
